import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.603 2.113a1.394 1.394 0 1 1-2.788 0 1.394 1.394 0 0 1 2.788 0ZM17.413 2.113c0-.14.014-.278.04-.411H6.296a2.138 2.138 0 0 1 .016.734h11.126a2.138 2.138 0 0 1-.025-.323ZM3.379 4.072c.204.086.424.142.655.16l.06.004-2.022 11.182a2.119 2.119 0 0 0-.526-.098l-.125-.003-.075.001L3.379 4.072ZM19.384 4.234a2.117 2.117 0 0 1-.593-.13l-2.028 11.212.115.004c.212.013.416.056.608.126L19.512 4.24l-.128-.005ZM14.626 17.444c0-.11.008-.218.024-.323H3.524a2.145 2.145 0 0 1-.015.733h11.156a2.134 2.134 0 0 1-.04-.41ZM2.815 17.444a1.394 1.394 0 1 1-2.787 0 1.394 1.394 0 0 1 2.787 0ZM16.753 18.838a1.394 1.394 0 1 0 0-2.788 1.394 1.394 0 0 0 0 2.788ZM19.54 3.506a1.394 1.394 0 1 0 0-2.787 1.394 1.394 0 0 0 0 2.787Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }